export default "__VITE_ASSET__Yw3v5FZL__"